const fr = {
    "Activate the create/remove space tool": "Activer l'outil de création / suppression d'espace",
    "Activate the global connect tool": "Activer l'outil de connexion globale",
    "Activate the hand tool": "Activer l'outil à main",
    "Activate the lasso tool": "Activer l'outil Lasso",
    "Ad-hoc": "Ad hoc",
    "Add Lane above": "Ajouter voie au dessus",
    "Add Lane below": "Ajouter voie ci-dessous",
    "Append Gateway": "Ajouter une passerelle",
    "Append Intermediate/Boundary Event": "Ajouter un événement intermédiaire / limite",
    "Append compensation activity": "Ajouter une activité de compensation",
    "Append {type}": "Ajouter {type}",
    "Business Rule Task": "Business Rule Task",
    "Call Activity": "Call Activity",
    "Cancel Boundary Event": "Annuler l'événement limite",
    "Cancel End Event": "Annuler l'événement final",
    "Change type": "Changer de type",
    "Collapsed Pool": "Piscine comprimée",
    "Compensation Boundary Event": "Événement frontalier de compensation",
    "Compensation End Event": "Événement de compensation finale",
    "Compensation Intermediate Throw Event": "Lancement de la compensation intermédiaire",
    "Compensation Start Event": "Événement pour commencer la compensation",
    "Complex Gateway": "Gateway complexe",
    "Conditional Boundary Event (non-interrupting)": "Événement frontière conditionnel (non-interruption)",
    "Conditional Boundary Event": "Événement frontière conditionnel",
    "Conditional Intermediate Catch Event": "Événement de capture intermédiaire conditionnel",
    "Conditional Start Event (non-interrupting)": "Événement de démarrage conditionnel (non-interruption)",
    "Conditional Start Event": "Événement de départ conditionnel",
    "Connect using Association": "Se connecter par association",
    "Connect using DataInputAssociation": "Se connecter à l'aide de l'association de saisie de données",
    "Connect using Sequence/MessageFlow or Association": "Connectez-vous en utilisant Sequence / MessageFlow ou Association",
    "Create Gateway": "Créer gateway",
    "Create IntermediateThrowEvent/BoundaryEvent": "Créer IntermediateThrowEvent / BoundaryEvent",
    "Create Pool/Participant": "Créer un pool / participant",
    "Create Start Timer Event": "Créer un événement de minuterie de démarrage",
    "Create expanded SubProcess": "Créer un processus secondaire étendu",
    "Create {type}": "Créer {type}",
    "Divide into three Lanes": "Diviser en trois voies",
    "Divide into two Lanes": "Diviser en deux voies",
    "End Event": "Fin de l'événement",
    "Error Boundary Event": "Événement de limite d'erreur",
    "Error End Event": "Erreur de fin d'événement",
    "Error Start Event": "Erreur de démarrage de l'événement",
    "Escalation Boundary Event (non-interrupting)": "Evénement de limitation d'escalade (non-interruption)",
    "Escalation Boundary Event": "Evénement de limitation d'escalade",
    "Escalation End Event": "Fin de l'escalade",
    "Escalation Intermediate Throw Event": "Escalade intermédiaire événement de lancement",
    "Escalation Start Event (non-interrupting)": "Escalation Start Event (pas d'interruption)",
    "Escalation Start Event": "Escalation Start Event",
    "Event Sub Process": "Processus d'événement secondaire",
    "Event based Gateway": "Gateway basé sur des événements",
    "Exclusive Gateway": "Gateway exclusif",
    "Expanded Pool": "Pool étendu",
    "Inclusive Gateway": "inclusive Gateway",
    "Intermediate Throw Event": "Événement de lancement intermédiaire",
    "Link Intermediate Catch Event": "Lien événement de capture intermédiaire",
    "Link Intermediate Throw Event": "Lien événement de lancement intermédiaire",
    "Loop": "Cycle continu",
    "Manual Task": "Activité manuelle",
    "Message Boundary Event (non-interrupting)": "Evénement de limite de message (non-interruption)",
    "Message Boundary Event": "Événement de frontière de message",
    "Message End Event": "Message de fin d'événement",
    "Message Intermediate Catch Event": "Evénement intermédiaire de capture de message",
    "Message Intermediate Throw Event": "Message d'événement de lancement intermédiaire",
    "Message Start Event (non-interrupting)": "Evénement de début de message (non interruption)",
    "Message Start Event": "Message Start Event",
    "Parallel Gateway": "Parallel Gateway",
    "Parallel Multi Instance": "Multi Instance Parallèle",
    "Receive Task": "Recevoir l'activité",
    "Remove": "supprimer",
    "Script Task": "Activité de script",
    "Send Task": "Envoyer une activité",
    "Sequential Multi Instance": "Multi-instance séquentielle",
    "Service Task": "Activité de service",
    "Signal Boundary Event (non-interrupting)": "Signal frontière événement (non-interruption)",
    "Signal Boundary Event": "Événement de limite de signal",
    "Signal End Event": "Signal End Event",
    "Signal Intermediate Catch Event": "Evénement de capture de signal intermédiaire",
    "Signal Intermediate Throw Event": "Événement de lancement de signal intermédiaire",
    "Signal Start Event (non-interrupting)": "Signal de démarrage (sans interruption)",
    "Signal Start Event": "Signal de départ",
    "Start Event": "Début de l'événement",
    "Sub Process (collapsed)": "Processus secondaire (compressé)",
    "Sub Process": "subprocess",
    "Task": "tâche",
    "Terminate End Event": "Événement de fin",
    "Timer Boundary Event (non-interrupting)": "Evénement limite (non-interruption)",
    "Timer Boundary Event": "Événement limite minuterie",
    "Timer Intermediate Catch Event": "Événement de capture intermédiaire minuterie",
    "Timer Start Event (non-interrupting)": "Evénement de début de minuterie (sans interruption)",
    "Timer Start Event": "Début de la minuterie",
    "Transaction": "transaction",
    "User Task": "Activité de l'utilisateur",
    "already rendered {element}": "déjà fait {element}",
    "diagram not part of bpmn:Definitions": "diagramme ne fait pas partie de bpmn: Définitions",
    "element required": "élément requis",
    "element {element} referenced by {referenced}#{property} not yet drawn": "element {element} indiqué par {referenced}#{property} pas encore dessiné",
    "failed to import {element}": "impossible d'importer {element}",
    "flow elements must be children of pools/participants": "Les éléments de flux doivent être des enfants de pool",
    "more than {count} child lanes": "plus que {count} voies secondaires",
    "no diagram to display": "aucun diagramme à afficher",
    "no parent for {element} in {parent}": "pas de parent pour {element} dans {parent}",
    "no process or collaboration to display": "aucun processus ou collaboration à afficher",
    "no shape type specified": "aucun type de formulaire spécifié"
};

export default fr;